// This file holds all our static data for the prototype.

export const mockCreator = {
  username: "gigiMusic",
  fullName: "Gigi Kiya",
  isVerified: true,
  profilePictureUrl: "https://i.pravatar.cc/100?u=gigi",
  phoneNumber: "+251911223344",
  bannerUrl:
    "https://placehold.co/400x160/1E293B/FFFFFF?text=Gigi+Kiya+Live&font=lora",
  bio: "Renowned Ethiopian singer blending traditional sounds with modern vibes. Welcome to my official hub! All my content, causes, and creations in one place.",
  stats: {
    followers: 1200000,
    subscribers: 2740,
  },
  // subscriptionTiers: [
  //   {
  //     id: 1,
  //     name: "Fan Club",
  //     priceETB: 75,
  //     perks: [
  //       "Exclusive updates",
  //       "Fan badge on profile",
  //       "Early access to music videos",
  //     ],
  //   },
  //   {
  //     id: 2,
  //     name: "VIP Circle",
  //     priceETB: 350,
  //     perks: [
  //       "All Fan Club perks",
  //       "Behind-the-scenes-content",
  //       "Monthly virtual Q&A session",
  //     ],
  //   },
  // ],
  subscriptionProducts: [
    {
      id: 1,
      name: "Fan Club",
      type: "Adnaki Content", // Internal Adnaki subscription
      platform: "Adnaki",
      logoUrl: "https://placehold.co/40x40/F1F5F9/7C3AED?text=A", // Generic Adnaki Logo
      priceETB: 75,
      perks: [
        "Exclusive updates",
        "Fan badge on profile",
        "Early access to music videos",
      ],
    },
    {
      id: 2,
      name: "VIP Circle",
      type: "Adnaki Content", // Internal Adnaki subscription
      platform: "Adnaki",
      logoUrl: "https://placehold.co/40x40/F1F5F9/7C3AED?text=A",
      priceETB: 350,
      perks: [
        "All Fan Club perks",
        "Behind-the-scenes-content",
        "Monthly virtual Q&A session",
      ],
    },
    {
      id: 3,
      name: "Sewasew Weekly",
      type: "External Platform", // New External subscription
      platform: "Sewasew",
      logoUrl: "https://placehold.co/40x40/10B981/FFFFFF?text=S", // Placeholder Sewasew Logo
      priceETB: 50,
      perks: [
        "Weekly access to my full catalog on Sewasew",
        "Offline downloads",
        "High-quality audio",
      ],
    },
    {
      id: 4,
      name: "Sewasew Monthly",
      type: "External Platform", // New External subscription
      platform: "Sewasew",
      logoUrl: "https://placehold.co/40x40/10B981/FFFFFF?text=S",
      priceETB: 180,
      perks: [
        "Monthly access to my full catalog on Sewasew",
        "Offline downloads & exclusive playlists",
        "High-quality audio",
      ],
    },
  ],
  posts: [
    {
      id: 1,
      type: "video",
      title: "Studio Session: New Single Preview!",
      isPremium: true,
      comments: 120,
      likes: 2500,
      status: "Published",
      publishDate: "2025-10-08",
    },
    {
      id: 2,
      type: "text",
      content:
        "So excited to announce my upcoming concert in Addis! Can't wait to see you all there. Get your tickets now!",
      isPremium: false,
      comments: 350,
      likes: 5200,
      status: "Published",
      publishDate: "2025-10-06",
    },
    {
      id: 3,
      type: "image",
      title: "Photoshoot Sneak Peek",
      isPremium: true,
      comments: 85,
      likes: 1800,
      status: "Draft",
      publishDate: "2025-10-15",
    },
  ],
  events: [
    {
      id: 1,
      type: "Virtual",
      title: "Live Acoustic Session",
      date: "Oct 25, 2025",
      priceETB: 500,
      ticketsSold: 150,
      status: "Upcoming",
    },
    {
      id: 2,
      type: "Live",
      title: "Unity Concert",
      date: "Nov 12, 2025",
      priceETB: 1200,
      ticketsSold: 850,
      status: "Upcoming",
    },
    {
      id: 3,
      type: "Live",
      title: "Album Launch Party",
      date: "Sep 05, 2025",
      priceETB: 420,
      ticketsSold: 500,
      status: "Past",
    },
  ],
  experiences: [
    { id: 1, title: "Personalized Birthday Video", priceETB: 2500 },
    { id: 2, title: "1-on-1 Music Feedback Session", priceETB: 7000 },
  ],
  experienceRequests: [
    {
      id: "ER001",
      fanName: "Alex Abera",
      experienceType: "Personalized Birthday Video",
      status: "New Request",
      requestDate: "2025-10-08",
    },
    {
      id: "ER002",
      fanName: "Betty Tesfaye",
      experienceType: "Personalized Birthday Video",
      status: "Completed",
      requestDate: "2025-10-05",
    },
    {
      id: "ER003",
      fanName: "Caleb Lemma",
      experienceType: "1-on-1 Music Feedback Session",
      status: "New Request",
      requestDate: "2025-10-07",
    },
  ],
  adCampaigns: [
    {
      id: "CAMP-002",
      name: "Safaricom Ethiopia", // Aligned with screenshot
      advertiser: "Safaricom",
      status: "Active",
      source: "Platform-Sourced",
      creatives: [
        {
          id: "CR-SAF-01",
          adType: "Video Pre-roll",
          adZone: "Video Player",
          mediaUrl: "https://placehold.co/400x225/34D399/FFFFFF?text=M-PESA+Video",
          link: "https://safaricom.et",
          impressions: 450000,
          ctr: "4.2%",
          revenueETB: 35000,
        },
        {
          id: "CR-SAF-02",
          adType: "Top Banner",
          adZone: "Home Feed",
          mediaUrl: "https://placehold.co/800x200/34D399/FFFFFF?text=Get+M-PESA",
          link: "https://safaricom.et",
          impressions: 120000,
          ctr: "2.8%",
          revenueETB: 15000,
        },
      ],
    },
    {
      id: "CAMP-004",
      name: "Awash Bank",
      advertiser: "Awash Bank",
      status: "Active",
      source: "Direct Sales",
      creatives: [
        {
          id: "CR-AWASH-01",
          adType: "Sidebar Ad",
          adZone: "Sidebar",
          mediaUrl: "https://placehold.co/300x600/1E3A8A/FFFFFF?text=Awash+Student+Account",
          link: "https://awashbank.com",
          impressions: 85000,
          ctr: "1.5%",
          revenueETB: 8500,
        },
      ],
    },
    {
      id: "CAMP-005",
      name: "BGI Ethiopia",
      advertiser: "BGI",
      status: "Active",
      source: "Platform-Sourced",
      creatives: [
        {
          id: "CR-BGI-01",
          adType: "Interstitial",
          adZone: "Mobile Fullscreen",
          mediaUrl: "https://placehold.co/375x812/F59E0B/FFFFFF?text=St+George",
          link: "https://bgiethiopia.com",
          impressions: 210000,
          ctr: "5.1%",
          revenueETB: 42000,
        },
        {
          id: "CR-BGI-02",
          adType: "In-Feed Image",
          adZone: "Home Feed",
          mediaUrl: "https://placehold.co/500x500/F59E0B/FFFFFF?text=Cheers",
          link: "https://bgiethiopia.com",
          impressions: 150000,
          ctr: "3.7%",
          revenueETB: 18000,
        },
      ],
    },
    {
      id: "CAMP-001",
      name: "Meta Abo Brewery Q4",
      advertiser: "Meta Abo Brewery",
      status: "Active",
      source: "Creator-Sourced",
      creatives: [
        {
          id: "CR-01A",
          adType: "Image Banner",
          adZone: "Prime Ad",
          mediaUrl:
            "https://placehold.co/800x200/1E293B/FFFFFF?text=Meta+Beer+Fest",
          link: "https://metabeer.com/fest",
          impressions: 120000,
          ctr: "2.5%",
          revenueETB: 15000,
        },
      ],
    },
  ],
  donationCampaigns: [
    {
      id: "DC-GIGI-01",
      title: "Local Artists Support Fund",
      beneficiary: "Self-Managed Artist Collective",
      goalETB: 100000,
      raisedETB: 75000,
      // ✨ NEW: Status for admin review
      status: "Approved",
      isCreatorSubmitted: true,
    },
    {
      id: "DC-GIGI-02",
      title: "Addis Animal Shelter Drive",
      beneficiary: "City Animal Welfare Group",
      goalETB: 50000,
      raisedETB: 0,
      status: "Pending", // This one is waiting for admin approval
      isCreatorSubmitted: true,
    },
  ],
  supportedCauseIds: ["PVC-01", "PVC-03"],
  courses: [
    {
      id: "C01",
      title: "The Fundamentals of Modern Ethiopian Music",
      priceETB: 4500,
      hitLink: "https://hit.edu/course/ethio-music-101",
    },
    {
      id: "C02",
      title: "Advanced Vocal Techniques",
      priceETB: 6000,
      hitLink: "https://hit.edu/course/vocals-201",
    },
  ],
  drops: [
    {
      id: "DRP01",
      productName: "Exclusive Signed Vinyl",
      quantity: 100,
      sold: 100,
      launchDate: "2025-10-01T10:00",
      status: "Completed",
    },
    {
      id: "DRP02",
      productName: "Limited Edition Art Print",
      quantity: 50,
      sold: 15,
      launchDate: "2025-10-15T18:00",
      status: "Active",
    },
  ],
  crowdfundingProjects: [
    {
      id: "CF01",
      title: "Funding My Next Album: 'Generations'",
      fundingGoalETB: 250000,
      currentFundingETB: 185000,
      endDate: "2025-11-30",
      status: "Active",
    },
  ],
  merchandise: [
    {
      id: 1,
      name: "Signature 'Gigi' Hoodie",
      priceETB: 1800,
      imageUrl: "https://placehold.co/200x200/334155/FFFFFF?text=Hoodie",
      stock: 50,
      sales: 120,
    },
    {
      id: 2,
      name: "Autographed Album Poster",
      priceETB: 950,
      imageUrl: "https://placehold.co/200x200/334155/FFFFFF?text=Poster",
      stock: 150,
      sales: 350,
    },
    {
      id: 3,
      name: "Custom Phone Case",
      priceETB: 600,
      imageUrl: "https://placehold.co/200x200/334155/FFFFFF?text=Case",
      stock: 25,
      sales: 85,
    },
  ],
  mockTransactions: [
    {
      id: "txn_101",
      date: "2025-10-11",
      type: "Commerce",
      description: "Sale: Signature 'Gigi' Hoodie",
      amount: 1800.0,
    },
    {
      id: "txn_102",
      date: "2025-10-11",
      type: "Subscription",
      description: "New Subscriber: Betty Tesfaye (Fan Club)",
      amount: 75.0,
    },
    {
      id: "txn_103",
      date: "2025-10-10",
      type: "Event",
      description: "Ticket Sale: Unity Concert",
      amount: 1200.0,
    },
    {
      id: "txn_104",
      date: "2025-10-10",
      type: "Commerce",
      description: "Sale: Autographed Album Poster",
      amount: 950.0,
    },
    {
      id: "txn_105",
      date: "2025-10-09",
      type: "Experience",
      description: "Request: Personalized Birthday Video",
      amount: 2500.0,
    },
    {
      id: "txn_106",
      date: "2025-10-09",
      type: "Subscription",
      description: "New Subscriber: Caleb Lemma (VIP Circle)",
      amount: 350.0,
    },
    {
      id: "txn_107",
      date: "2025-10-08",
      type: "MasterClass",
      description: "Enrollment: The Fundamentals of Modern Ethiopian Music",
      amount: 4500.0,
    },
    {
      id: "txn_108",
      date: "2025-10-08",
      type: "Commerce",
      description: "Sale: Signature 'Gigi' Hoodie",
      amount: 1800.0,
    },
    {
      id: "txn_109",
      date: "2025-10-07",
      type: "Event",
      description: "Ticket Sale: Unity Concert",
      amount: 1200.0,
    },
    {
      id: "txn_110",
      date: "2025-10-07",
      type: "Donation",
      description: "Donation: Music Education for Kids",
      amount: 500.0,
    },
    {
      id: "txn_111",
      date: "2025-10-06",
      type: "Commerce",
      description: "Sale: Custom Phone Case",
      amount: 600.0,
    },
    {
      id: "txn_112",
      date: "2025-10-11",
      type: "Affiliate",
      description: "Commission from RIDE referral",
      amount: 150.0,
    },
    {
      id: "txn_113",
      date: "2025-10-10",
      type: "Affiliate",
      description: "Commission from Sheger Gebeta (GIGI10)",
      amount: 250.0,
    },
    {
      id: "txn_114",
      date: "2025-10-09",
      type: "Affiliate",
      description: "Commission from RIDE referral",
      amount: 150.0,
    },
    {
      id: "txn_115",
      date: "2025-10-11",
      type: "Ad Revenue",
      description: "Payment from Meta Abo Brewery",
      amount: 37000.0,
    },
    {
      id: "txn_116",
      date: "2025-10-09",
      type: "Ad Revenue",
      description: "Payment from Safaricom Ethiopia",
      amount: 53000.0,
    },
  ],
  dashboardStats: {
    revenue: { value: "45,750 ETB", change: "+12.5%" },
    subscribers: { value: "2,740", change: "+88" },
    views: { value: "1.2M", change: "+3.2%" },
    engagement: { value: "6.8%", change: "-0.5%" },
  },
  analytics: {
    revenueByMonth: [
      { month: "May", revenue: 25000 },
      { month: "Jun", revenue: 32000 },
      { month: "Jul", revenue: 28000 },
      { month: "Aug", revenue: 41000 },
      { month: "Sep", revenue: 38000 },
      { month: "Oct", revenue: 45750 },
    ],
    followerGrowth: [
      { label: "May", value: 10200 },
      { label: "Jun", value: 10800 },
      { label: "Jul", value: 11100 },
      { label: "Aug", value: 11500 },
      { label: "Sep", value: 11900 },
      { label: "Oct", value: 12400 },
    ],
    audienceAge: [
      { label: "18-24", value: 35 },
      { label: "25-34", value: 45 },
      { label: "35-44", value: 15 },
      { label: "45+", value: 5 },
    ],
    deviceUsage: [
      { label: "Mobile", value: 82 },
      { label: "Desktop", value: 15 },
      { label: "Tablet", value: 3 },
    ],
    revenueSources: [
      { label: "Subscriptions", value: 15250, color: "#7C3AED" },
      { label: "Merchandise", value: 8500, color: "#10B981" },
      { label: "Ads", value: 12000, color: "#F59E0B" },
      { label: "Tips/Other", value: 10000, color: "#3B82F6" },
    ],
    topPosts: [
      {
        id: 2,
        title: "Concert Announcement",
        views: 152000,
        engagement: "12.1%",
        shares: 850,
      },
      {
        id: 1,
        title: "Studio Session Preview",
        views: 98000,
        engagement: "9.8%",
        shares: 420,
      },
    ],
  },
  broadcastHistory: [
    {
      id: 1,
      channel: "Email",
      audience: "VIP Circle",
      subject: "Exclusive Backstage Photos!",
      sentDate: "2025-10-07",
    },
    {
      id: 2,
      channel: "Push Notification",
      audience: "All Subscribers",
      subject: "New single drops tomorrow at noon!",
      sentDate: "2025-10-03",
    },
    {
      id: 3,
      channel: "SMS",
      audience: "Live Concert Attendees",
      subject: "Thanks for coming to the show!",
      sentDate: "2025-09-28",
    },
  ],
  teamMembers: [
    {
      id: 1,
      name: "Abebe Bikila",
      email: "abebe@example.com",
      role: "Admin",
      avatarUrl: "https://i.pravatar.cc/100?u=abebe",
    },
    {
      id: 2,
      name: "Hana Girma",
      email: "hana@example.com",
      role: "Editor",
      avatarUrl: "https://i.pravatar.cc/100?u=hana",
    },
    {
      id: 3,
      name: "Samuel Tadesse",
      email: "samuel@example.com",
      role: "Finance",
      avatarUrl: "https://i.pravatar.cc/100?u=samuel",
    },
  ],
  activityFeed: [
    {
      id: 1,
      type: "New Subscriber",
      text: "Alex Abera subscribed to your VIP Circle.",
      time: "1h ago",
    },
    {
      id: 2,
      type: "New Tip",
      text: "Betty Tesfaye sent a 100 ETB tip.",
      time: "3h ago",
    },
    {
      id: 3,
      type: "Post Published",
      text: 'Your post "Studio Session" was published.',
      time: "Yesterday",
    },
  ],
  opportunityFeed: [
    {
      id: "AD-001",
      advertiser: "Safaricom Ethiopia",
      campaign: "M-PESA Launch",
      type: "Banner Ad",
      revenueShare: "70% Creator / 30% Adnaki",
    },
    {
      id: "PRT-002",
      brand: "Sheger Gebeta",
      offer: "Custom creator discount codes",
      type: "Partnership",
    },
  ],
  subscribersList: [
    {
      id: "S001",
      name: "Alex Abera",
      email: "alex@example.com",
      tier: "VIP Circle",
      joinDate: "2025-09-15",
    },
    {
      id: "S002",
      name: "Betty Tesfaye",
      email: "betty@example.com",
      tier: "Fan Club",
      joinDate: "2025-09-21",
    },
    {
      id: "S003",
      name: "Caleb Lemma",
      email: "caleb@example.com",
      tier: "Fan Club",
      joinDate: "2025-10-02",
    },
  ],
  featuredCause: {
    title: "Music Education for Kids",
    organization: "Ethiopian Youth Music Initiative",
    description:
      "Help us provide musical instruments and education to underprivileged children in Addis Ababa.",
    goalETB: 500000,
    raisedETB: 315000,
  },
  partnerships: [
    {
      id: 1,
      brand: "Dashen Bank",
      offer: "Get 5% cashback with a new Amole account.",
      type: "Link",
      cta: "Get Offer",
      logoUrl: "https://placehold.co/40x40/FBBF24/FFFFFF?text=DB",
    },
    {
      id: 2,
      brand: "Sheger Gebeta",
      offer: "Use code GIGI10 for 10% off your first order.",
      type: "Code",
      cta: "Copy Code",
      logoUrl: "https://placehold.co/40x40/34D399/FFFFFF?text=SG",
    },
    {
      id: 3,
      brand: "RIDE",
      offer: "Get 50 ETB off your first 3 rides.",
      type: "Link",
      cta: "Sign Up",
      logoUrl: "https://placehold.co/40x40/3B82F6/FFFFFF?text=R",
    },
  ],
  mediaLibrary: [
    {
      id: "M001",
      fileName: "profile-pic-2025.jpg",
      fileType: "Image",
      thumbnailUrl: "https://i.pravatar.cc/150?u=gigi-profile",
      uploadDate: "2025-10-01",
    },
    {
      id: "M002",
      fileName: "concert-banner-nov.png",
      fileType: "Image",
      thumbnailUrl: "https://placehold.co/150x150/1E293B/FFFFFF?text=Banner",
      uploadDate: "2025-09-28",
    },
    {
      id: "M003",
      fileName: "hoodie-design-final.png",
      fileType: "Image",
      thumbnailUrl: "https://placehold.co/150x150/334155/FFFFFF?text=Hoodie",
      uploadDate: "2025-09-25",
    },
    {
      id: "M004",
      fileName: "behind-the-scenes.mp4",
      fileType: "Video",
      thumbnailUrl: "https://placehold.co/150x150/7C3AED/FFFFFF?text=Video",
      uploadDate: "2025-09-22",
    },
    {
      id: "M005",
      fileName: "logo-transparent.png",
      fileType: "Image",
      thumbnailUrl: "https://placehold.co/150x150/F1F5F9/7C3AED?text=GK",
      uploadDate: "2025-09-20",
    },
  ],
  audienceList: [
    {
      id: "F001",
      username: "superfan_alex",
      status: "VIP Subscriber",
      lastInteraction: "Subscription",
      date: "2025-09-15",
      groups: ["VIPs"],
    },
    {
      id: "F002",
      username: "betty_t",
      status: "Follower",
      lastInteraction: "Merch Purchase",
      date: "2025-10-01",
      groups: ["Merch Buyers"],
    },
    {
      id: "F003",
      username: "caleb_lemma",
      status: "Fan Club Subscriber",
      lastInteraction: "Subscription",
      date: "2025-10-02",
      groups: [],
    },
    {
      id: "F004",
      username: "dani_g",
      status: "Follower",
      lastInteraction: "Event Ticket",
      date: "2025-09-20",
      groups: ["Concert Attendees"],
    },
    {
      id: "F005",
      username: "hana_girma",
      status: "Follower",
      lastInteraction: "Follow",
      date: "2025-08-11",
      groups: [],
    },
  ],
  customAudienceGroups: ["VIPs", "Merch Buyers", "Concert Attendees"],
  wallet: {
    currentBalanceETB: 45750.0,
    payoutMethods: [
      {
        id: "pm_1",
        type: "Bank",
        detail: "Commercial Bank of Ethiopia",
        last4: "...1234",
      },
      {
        id: "pm_2",
        type: "Mobile Money",
        detail: "Telebirr",
        last4: "...5678",
      },
    ],
    transactionHistory: [
      {
        id: "txn_1",
        date: "2025-10-10",
        type: "Earning",
        description: "Subscription revenue",
        amount: 15250.0,
      },
      {
        id: "txn_2",
        date: "2025-10-08",
        type: "Broadcast Fee",
        description: "SMS to 1,500 fans",
        amount: -750.0,
      },
      {
        id: "txn_3",
        date: "2025-10-05",
        type: "Withdrawal",
        description: "To CBE (...1234)",
        amount: -20000.0,
      },
      {
        id: "txn_4",
        date: "2025-10-02",
        type: "Earning",
        description: "Merch sales",
        amount: 8500.0,
      },
    ],
  },
  creatorAffiliateLinks: [
    {
      id: "CAL-01",
      platform: "Amazon Associates",
      productName: "Studio Microphone Kit",
      link: "https://amzn.to/xyz123",
      clicks: 1250,
      conversions: 75,
      earningsETB: 4500,
    },
    {
      id: "CAL-02",
      platform: "ClickBank",
      productName: "Online Music Production Course",
      link: "https://ckbk.to/abc456",
      clicks: 820,
      conversions: 42,
      earningsETB: 8250,
    },
  ],
  conversations: [
    {
      id: "CONV-001",
      creatorName: "Alex Abera",
      creatorProfilePictureUrl: "https://i.pravatar.cc/100?u=alex",
      lastMessage: "Thank you so much! That's perfect.",
      lastMessageTimestamp: "2h ago",
      isRead: true,
      messages: [
        {
          id: "msg1",
          sender: "fan",
          text: "Hi Gigi! I loved the new single. Can't wait for the concert!",
          timestamp: "Yesterday",
        },
        {
          id: "msg2",
          sender: "creator",
          text: "Hey Alex! So glad you enjoyed it. It means a lot.",
          timestamp: "Yesterday",
        },
        {
          id: "msg3",
          sender: "fan",
          text: "I have a quick question about the VIP package for the concert. Does it include a meet and greet?",
          timestamp: "4h ago",
        },
        {
          id: "msg4",
          sender: "creator",
          text: "It does! It includes a pre-show meet and greet and a signed poster.",
          timestamp: "3h ago",
        },
        {
          id: "msg5",
          sender: "fan",
          text: "Thank you so much! That's perfect.",
          timestamp: "2h ago",
        },
      ],
    },
    {
      id: "CONV-002",
      creatorName: "Betty Tesfaye",
      creatorProfilePictureUrl: "https://i.pravatar.cc/100?u=betty",
      lastMessage: "Can't wait to see the new merch!",
      lastMessageTimestamp: "1d ago",
      isRead: false,
      messages: [
        {
          id: "msg1",
          sender: "fan",
          text: "Hi Gigi, are you releasing new hoodies soon?",
          timestamp: "2d ago",
        },
        {
          id: "msg2",
          sender: "creator",
          text: "Yes Betty! Next week. Stay tuned!",
          timestamp: "1d ago",
        },
        {
          id: "msg3",
          sender: "fan",
          text: "Can't wait to see the new merch!",
          timestamp: "1d ago",
        },
      ],
    },
    {
      id: "CONV-003",
      creatorName: "Caleb Lemma",
      creatorProfilePictureUrl: "https://i.pravatar.cc/100?u=caleb",
      lastMessage: "Thanks for the shoutout!",
      lastMessageTimestamp: "3d ago",
      isRead: true,
      messages: [
        {
          id: "msg1",
          sender: "creator",
          text: "Hey Caleb, thanks for joining the VIP Circle!",
          timestamp: "3d ago",
        },
        {
          id: "msg2",
          sender: "fan",
          text: "Thanks for the shoutout!",
          timestamp: "3d ago",
        },
      ],
    },
    {
      id: "CONV-004",
      creatorName: "Dani G",
      creatorProfilePictureUrl: "https://i.pravatar.cc/100?u=dani",
      lastMessage: "Is the concert all ages?",
      lastMessageTimestamp: "5h ago",
      isRead: false,
      messages: [
        {
          id: "msg1",
          sender: "fan",
          text: "Is the concert all ages?",
          timestamp: "5h ago",
        },
      ],
    },
    {
      id: "CONV-002",
      creatorName: "Betty Tesfaye",
      creatorProfilePictureUrl: "https://i.pravatar.cc/100?u=betty",
      lastMessage: "Just sent the details for the birthday video. Thank you!",
      lastMessageTimestamp: "1d ago",
      isRead: false, // This conversation has an unread message
      messages: [
        {
          id: "msg6",
          sender: "creator",
          text: "Hi Betty, your Experience request for the birthday video has been accepted! Please send over the details.",
          timestamp: "2d ago",
        },
        {
          id: "msg7",
          sender: "fan",
          text: "Just sent the details for the birthday video. Thank you!",
          timestamp: "1d ago",
        },
      ],
    },
    {
      id: "CONV-003",
      creatorName: "Caleb Lemma",
      creatorProfilePictureUrl: "https://i.pravatar.cc/100?u=caleb",
      lastMessage: "No problem, take your time.",
      lastMessageTimestamp: "3d ago",
      isRead: true,
      messages: [
        {
          id: "msg8",
          sender: "creator",
          text: "Hey Caleb, thanks for your patience. I'll get to your music feedback session request this weekend.",
          timestamp: "3d ago",
        },
        {
          id: "msg9",
          sender: "fan",
          text: "No problem, take your time.",
          timestamp: "3d ago",
        },
      ],
    },
  ],
};

export const featuredCreators = [
  {
    id: 1,
    name: "Gigi Kiya",
    username: "gigiMusic",
    displayName: "Gigi Kiya",
    bio: "Renowned Ethiopian singer blending traditional sounds with modern vibes.",
    profilePictureUrl: "https://i.pravatar.cc/100?u=gigi",
    isVerified: true,
    tags: ["Music", "Pop", "Traditional"],
    followers: "1.2M",
  },
  {
    id: 2,
    name: "Comedian Eshetu",
    username: "eshetu",
    displayName: "Comedian Eshetu",
    bio: "Ethiopia's favorite comedian and host of Donkey Tube.",
    profilePictureUrl: "https://i.pravatar.cc/100?u=eshetu",
    isVerified: true,
    tags: ["Comedy", "TV", "Satire"],
    followers: "850K",
  },
  {
    id: 3,
    name: "Rakeb Alemayehu",
    username: "rakeb",
    displayName: "Rakeb Alemayehu",
    bio: "TV host, actress, and social media influencer.",
    profilePictureUrl: "https://i.pravatar.cc/100?u=rakeb",
    isVerified: true,
    tags: ["Lifestyle", "TV", "Fashion"],
    followers: "420K",
  },
  {
    id: 4,
    name: "Gursha Dessert",
    username: "gursha",
    displayName: "Gursha Dessert",
    bio: "Exploring the best of Ethiopian cuisine and food culture.",
    profilePictureUrl: "https://i.pravatar.cc/100?u=gursha",
    isVerified: true,
    tags: ["Food", "Culture", "Vlog"],
    followers: "125K",
  },
  {
    id: 5,
    name: "Sewasew Music",
    username: "sewasew",
    displayName: "Sewasew",
    bio: "Supporting Ethiopian music and cultural heritage.",
    profilePictureUrl: "https://i.pravatar.cc/100?u=sewasew",
    isVerified: true,
    tags: ["Music", "Philanthropy", "Traditional"],
    followers: "230K",
  },
];

export const mockFan = {
  username: "superfan_alex",
  fullName: "Alex Abera",
  phoneNumber: "+251929290950",
  profilePictureUrl: "https://i.pravatar.cc/100?u=alex",
  wallet: {
    currentBalanceETB: 750.0,
    paymentMethods: [
      {
        id: "pm_fan_1",
        type: "Bank",
        provider: "Commercial Bank of Ethiopia",
        detail: "Account ending in 1234",
        logo: "🏦",
      },
      {
        id: "pm_fan_2",
        type: "Mobile Money",
        provider: "Telebirr",
        detail: "Phone ending in 5678",
        logo: "📱",
      },
    ],
    transactionHistory: [
      {
        id: "txn_fan_1",
        date: "Oct 11, 2025",
        type: "Top-up",
        description: "Added funds via Inverse",
        amount: 1000.0,
        status: "Completed",
      },
      {
        id: "txn_fan_2",
        date: "Oct 09, 2025",
        type: "Purchase",
        description: "Ticket: Gigi Kiya - Unity Concert",
        amount: -250.0,
        status: "Completed",
      },
      {
        id: "txn_fan_3",
        date: "Oct 05, 2025",
        type: "Subscription",
        description: "Subscribed to Gigi Kiya (Fan Club)",
        amount: -75.0,
        status: "Completed",
      },
    ],
  },
  email: "alex@fan.com",
  library: {
    subscriptions: [
      {
        id: "SUB-001",
        creatorName: "Gigi Kiya",
        creatorUsername: "gigiMusic",
        creatorProfilePicture: "https://i.pravatar.cc/100?u=gigi",
        tierName: "VIP Circle",
        tierPrice: "350 ETB/mo",
        status: "Active",
        nextBillingDate: "2025-11-10",
        joinDate: "2025-09-15"
      },
      {
        id: "SUB-002",
        creatorName: "Comedian Eshetu",
        creatorUsername: "eshetu",
        creatorProfilePicture: "https://i.pravatar.cc/100?u=eshetu",
        tierName: "Fan Club",
        tierPrice: "75 ETB/mo",
        status: "Active",
        nextBillingDate: "2025-10-25",
        joinDate: "2025-08-20"
      },
      {
        id: "sub_sewasew",
        creatorName: "Sewasew Music",
        creatorUsername: "sewasew",
        creatorProfilePicture: "https://i.pravatar.cc/100?u=sewasew",
        tierName: "Sewasew Weekly",
        tierPrice: "50 ETB/wk",
        status: "Active",
        renewalDate: "October 15, 2025",
      }
    ],
    purchases: [
      {
        id: "PURCH-001",
        title: "Exclusive Acoustic Album",
        creatorName: "Gigi Kiya",
        thumbnailUrl: "https://placehold.co/200x200/4F46E5/FFFFFF?text=Album",
        fileType: "Audio",
        purchaseDate: "2025-10-01"
      },
      {
        id: "PURCH-002",
        title: "Mastering Vocals Masterclass",
        creatorName: "Gigi Kiya",
        thumbnailUrl: "https://placehold.co/200x200/7C3AED/FFFFFF?text=Course",
        fileType: "Video",
        purchaseDate: "2025-09-25"
      },
      {
        id: "pur_hoodie",
        type: "Merchandise",
        title: "Signature 'Gigi' Hoodie",
        creatorName: "Gigi Kiya",
        thumbnailUrl: "https://images.unsplash.com/photo-1556905055-8f358a7a47b2?w=400",
        purchaseDate: "October 1, 2025",
        priceETB: 1800.0,
      }
    ],
    experiences: [
      {
        id: "exp_1",
        creatorName: "Gigi Kiya",
        experienceName: "Personalized Birthday Video",
        requestDate: "October 8, 2025",
        status: "Completed",
      },
      {
        id: "exp_2",
        creatorName: "Rakeb Alemayehu",
        experienceName: "1-on-1 Portfolio Review",
        requestDate: "October 11, 2025",
        status: "Pending",
      },
    ],
    courses: [
      {
        id: "course_1",
        title: "The Fundamentals of Modern Ethiopian Music",
        creatorName: "Gigi Kiya",
        link: "https://hit.edu/course/ethio-music-101",
      },
    ],
    saved: [],
  },
  donations: [
    {
      id: "DON-001",
      creatorName: "Sewasew Music",
      amount: "500 ETB",
      campaign: "Local Artists Support Fund",
      date: "2025-10-05"
    }
  ],
  tips: [
    {
      id: "TIP-001",
      creatorName: "Comedian Eshetu",
      amount: "100 ETB",
      date: "2025-10-10"
    }
  ],
  following: ["gigiMusic", "eshetu", "rakeb", "gursha", "sewasew"],
};
export const platformAffiliateDeals = [
  {
    id: "PAD-01",
    brand: "RIDE",
    offer: "15% commission on the first 5 rides for new users you refer.",
    type: "Referral Link",
    logoUrl: "https://placehold.co/40x40/3B82F6/FFFFFF?text=R",
    isActivated: true,
    creatorLink: "https://ride.adn.ki/gigiMusic", // ✨ New Field
    creatorCode: null,
    clicks: 480,
    conversions: 32,
    earningsETB: 4800,
  },
  {
    id: "PAD-02",
    brand: "Sheger Gebeta",
    offer: "Give your followers 10% off their first order, get 10% commission.",
    type: "Discount Code",
    logoUrl: "https://placehold.co/40x40/34D399/FFFFFF?text=SG",
    isActivated: true,
    creatorLink: null,
    creatorCode: "GIGI10", // ✨ New Field
    clicks: 620,
    conversions: 55,
    earningsETB: 6800,
  },
  {
    id: "PAD-03",
    brand: "Zemen Bank",
    offer:
      "Earn 500 ETB for every new user who opens an account via your link.",
    type: "Referral Link",
    logoUrl: "https://placehold.co/40x40/A855F7/FFFFFF?text=ZB",
    isActivated: false,
    creatorLink: null, // Populated on activation
    creatorCode: null,
    clicks: 420,
    conversions: 42,
    earningsETB: 6969,
  },
];

export const platformAdOpportunities = [
  {
    id: "CAMP-002",
    name: "Safaricom Ethiopia",
    advertiser: "Safaricom",
    status: "Active",
    source: "Platform-Sourced",
    description: "Promote M-PESA's new features to your audience.",
    rate: "CPM: 50 ETB",
    minFollowers: 10000,
    placementZones: ["Home Feed", "Video Player"],
    revenueModel: "CPM",
    creatives: [
      {
        id: "CR-SAF-01",
        adType: "Video Pre-roll",
        adZone: "Video Player",
        mediaUrl: "https://placehold.co/400x225/34D399/FFFFFF?text=M-PESA+Video",
        link: "https://safaricom.et",
        impressions: 450000,
        ctr: "4.2%",
        revenueETB: 35000,
      },
      {
        id: "CR-SAF-02",
        adType: "Top Banner",
        adZone: "Home Feed",
        mediaUrl: "https://placehold.co/800x200/34D399/FFFFFF?text=Get+M-PESA",
        link: "https://safaricom.et",
        impressions: 120000,
        ctr: "2.8%",
        revenueETB: 15000,
      },
    ],
  },
  {
    id: "CAMP-004",
    name: "Awash Bank",
    advertiser: "Awash Bank",
    status: "Active",
    source: "Direct Sales",
    description: "Exclusive partnership for student account promotion.",
    rate: "One-time: 15,000 ETB",
    minFollowers: 5000,
    placementZones: ["Sidebar"],
    revenueModel: "Flat Fee",
    creatives: [
      {
        id: "CR-AWASH-01",
        adType: "Sidebar Ad",
        adZone: "Sidebar",
        mediaUrl: "https://placehold.co/300x600/1E3A8A/FFFFFF?text=Awash+Student+Account",
        link: "https://awashbank.com",
        impressions: 85000,
        ctr: "1.5%",
        revenueETB: 8500,
      },
    ],
  },
  {
    id: "CAMP-005",
    name: "BGI Ethiopia",
    advertiser: "BGI",
    status: "Active",
    source: "Platform-Sourced",
    description: "Seasonal campaign for St. George Beer.",
    rate: "CPC: 5 ETB",
    minFollowers: 20000,
    placementZones: ["Mobile Fullscreen", "Home Feed"],
    revenueModel: "CPC",
    creatives: [
      {
        id: "CR-BGI-01",
        adType: "Interstitial",
        adZone: "Mobile Fullscreen",
        mediaUrl: "https://placehold.co/375x812/F59E0B/FFFFFF?text=St+George",
        link: "https://bgiethiopia.com",
        impressions: 210000,
        ctr: "5.1%",
        revenueETB: 42000,
      },
      {
        id: "CR-BGI-02",
        adType: "In-Feed Image",
        adZone: "Home Feed",
        mediaUrl: "https://placehold.co/500x500/F59E0B/FFFFFF?text=Cheers",
        link: "https://bgiethiopia.com",
        impressions: 150000,
        ctr: "3.7%",
        revenueETB: 18000,
      },
    ],
  },
  {
    id: "CAMP-001",
    name: "Meta Abo Brewery Q4",
    advertiser: "Meta Abo Brewery",
    status: "Active",
    source: "Creator-Sourced",
    description: "Brand awareness for the new lager.",
    rate: "CPM: 40 ETB",
    minFollowers: 5000,
    placementZones: ["Prime Ad"],
    revenueModel: "CPM",
    creatives: [
      {
        id: "CR-01A",
        adType: "Image Banner",
        adZone: "Prime Ad",
        mediaUrl: "https://placehold.co/800x200/1E293B/FFFFFF?text=Meta+Beer+Fest",
        link: "https://metabeer.com/fest",
        impressions: 120000,
        ctr: "2.5%",
        revenueETB: 15000,
      },
    ],
  },
];

export const platformStats = {
  totalUsers: { value: "1,250,840" },
  totalCreators: { value: "5,210" },
  totalRevenue: { value: "18,450,900 ETB" },
  pendingVerifications: { value: "15" },
  monthlySignups: [
    { month: "May", count: 850 },
    { month: "Jun", count: 1100 },
    { month: "Jul", count: 950 },
    { month: "Aug", count: 1300 },
    { month: "Sep", count: 1520 },
    { month: "Oct", count: 1810 },
  ],
  recentCreators: [
    {
      name: "Yohannes Sisters' Kitchen",
      joined: "2 hours ago",
      avatarUrl: "https://i.pravatar.cc/100?u=yohannes",
    },
    {
      name: "Addis Tech Reviews",
      joined: "1 day ago",
      avatarUrl: "https://i.pravatar.cc/100?u=addistech",
    },
    {
      name: "Ethio Fitness",
      joined: "2 days ago",
      avatarUrl: "https://i.pravatar.cc/100?u=ethiofit",
    },
  ],
  revenueBreakdown: [
    { source: "Subscriptions", amount: 9850000, color: "bg-purple-500" },
    { source: "Commerce", amount: 5500500, color: "bg-sky-500" },
    { source: "Platform Fees", amount: 3100400, color: "bg-green-500" },
  ],
  activityFeed: [
    {
      type: "New Creator",
      text: "Comedian Eshetu has been verified.",
      time: "1h ago",
    },
    {
      type: "New Subscription",
      text: "Alex Abera subscribed to Gigi Kiya's VIP Circle.",
      time: "3h ago",
    },
    {
      type: "Payout",
      text: "Monthly payouts have been processed.",
      time: "8h ago",
    },
  ],
  transactionVolume: [
    { date: "Oct 10", count: 850 },
    { date: "Oct 11", count: 1200 },
    { date: "Oct 12", count: 980 },
    { date: "Oct 13", count: 1540 },
    { date: "Oct 14", count: 2100 },
    { date: "Oct 15", count: 1890 },
    { date: "Oct 16", count: 2450 },
  ],
  systemAlerts: [
    { id: 1, type: "warning", message: "Server load above 85% in Region East", time: "5m ago" },
    { id: 2, type: "info", message: "Backup completed successfully", time: "1h ago" },
    { id: 3, type: "error", message: "Failed transaction payout for CREATOR-99", time: "2h ago" },
  ],
  creatorStatus: {
    active: 4120,
    pending: 840,
    rejected: 250
  }
};

export const allUsers = [
  {
    id: "U001",
    name: "Gigi Kiya",
    email: "gigi@example.com",
    role: "Creator",
    status: "Active",
    joinDate: "2025-01-15",
  },
  {
    id: "U002",
    name: "Alex Abera",
    email: "alex@example.com",
    role: "Fan",
    status: "Active",
    joinDate: "2025-02-20",
  },
  {
    id: "U003",
    name: "Comedian Eshetu",
    email: "eshetu@example.com",
    role: "Creator",
    status: "Active",
    joinDate: "2025-03-01",
  },
  {
    id: "U004",
    name: "Liya Kebede",
    email: "liya@example.com",
    role: "Fan",
    status: "Suspended",
    joinDate: "2025-03-10",
  },
  {
    id: "U005",
    name: "Rakeb Alemayehu",
    email: "rakeb@example.com",
    role: "Creator",
    status: "Active",
    joinDate: "2025-04-22",
  },
  {
    id: "U006",
    name: "Samuel Bekele",
    email: "samuel.b@example.com",
    role: "Fan",
    status: "Active",
    joinDate: "2025-05-18",
  },
];

export const creatorPipeline = [
  {
    id: "C001",
    name: "Gigi Kiya",
    category: "Music",
    status: "Active",
    contact: "gigi@example.com",
  },
  {
    id: "C003",
    name: "Comedian Eshetu",
    category: "Comedy",
    status: "Active",
    contact: "eshetu@example.com",
  },
  {
    id: "C005",
    name: "Rakeb Alemayehu",
    category: "Art & Design",
    status: "Active",
    contact: "rakeb@example.com",
  },
  {
    id: "C007",
    name: "Addis Insight",
    category: "News & Media",
    status: "Onboarding",
    contact: "contact@addisinsight.com",
  },
  {
    id: "C008",
    name: "Ethio Kicks",
    category: "Fashion",
    status: "Contacted",
    contact: "info@ethiokicks.com",
  },
  {
    id: "C009",
    name: "Sheba Plate",
    category: "Food",
    status: "Prospective",
    contact: "N/A",
  },
];

export const platformDeals = {
  ads: [
    {
      id: "AD-001",
      advertiser: "Safaricom Ethiopia",
      campaign: "M-PESA Launch",
      revenueShare: "70/30",
      status: "Active",
    },
    {
      id: "AD-002",
      advertiser: "Awash Bank",
      campaign: "New Mobile App",
      revenueShare: "70/30",
      status: "Active",
    },
    {
      id: "AD-003",
      advertiser: "BGI Ethiopia",
      campaign: "St. George Beer Fest",
      revenueShare: "65/35",
      status: "Draft",
    },
  ],
  partnerships: [
    {
      id: "PRT-001",
      brand: "RIDE",
      offer: "15% new rider commission",
      type: "Affiliate",
      status: "Active",
    },
    {
      id: "PRT-002",
      brand: "Sheger Gebeta",
      offer: "Custom creator discount codes",
      type: "Discount Code",
      status: "Active",
    },
  ],
};

export const supportTickets = [
  {
    id: "TKT-001",
    subject: "Payout issue for September",
    user: "Gigi Kiya",
    status: "Open",
    lastUpdate: "2 hours ago",
    conversation: [
      {
        from: "Gigi Kiya",
        message:
          "Hi team, I have not received my payout for September yet. Can you please check on this?",
      },
    ],
  },
  {
    id: "TKT-002",
    subject: "Cannot upload video content",
    user: "Addis Tech Reviews",
    status: "Open",
    lastUpdate: "5 hours ago",
    conversation: [
      {
        from: "Addis Tech Reviews",
        message:
          "I keep getting an error when I try to upload a new video. The file is an MP4 under 500MB.",
      },
    ],
  },
  {
    id: "TKT-003",
    subject: "Question about merch fulfillment",
    user: "Ethio Fitness",
    status: "Pending",
    lastUpdate: "1 day ago",
    conversation: [
      {
        from: "Ethio Fitness",
        message: "How long does delivery usually take with RIDE?",
      },
      {
        from: "Adnaki Support",
        message:
          "Hi! Deliveries within Addis are typically completed within 24-48 hours.",
      },
    ],
  },
];

export const platformVettedCauses = [
  {
    id: "PVC-01",
    title: "Music Education for Kids",
    organization: "Ethiopian Youth Music Initiative",
    description:
      "Help us provide musical instruments and education to underprivileged children in Addis Ababa.",
    logoUrl: "https://placehold.co/40x40/3B82F6/FFFFFF?text=YM",
  },
  {
    id: "PVC-02",
    title: "Clean Water Project",
    organization: "WaterFirst Ethiopia",
    description:
      "Support our mission to bring clean and safe drinking water to rural communities.",
    logoUrl: "https://placehold.co/40x40/06B6D4/FFFFFF?text=WF",
  },
  {
    id: "PVC-03",
    title: "Tech Hub for Youth",
    organization: "Addis Coder's Initiative",
    description:
      "Fund a new tech hub to provide coding education and resources for young people in the city.",
    logoUrl: "https://placehold.co/40x40/8B5CF6/FFFFFF?text=AC",
  },
];

export const mockAds = [
  {
    id: "ad_1",
    type: "ad",
    advertiser: "Safaricom Ethiopia",
    title: "M-PESA: The Future of Mobile Money",
    content: "Send money, pay bills, and buy airtime with ease. Download the app today!",
    mediaUrl: "https://placehold.co/600x400/34D399/FFFFFF?text=M-PESA+Ad",
    cta: "Download Now",
    link: "https://safaricom.et/mpesa",
  },
  {
    id: "ad_2",
    type: "ad",
    advertiser: "Zemen Bank",
    title: "Save Big with Zemen",
    content: "Open a savings account and get 5% interest. Secure your future.",
    mediaUrl: "https://placehold.co/600x400/A855F7/FFFFFF?text=Zemen+Bank",
    cta: "Learn More",
    link: "https://zemenbank.com",
  },
];

export const mockPosts = [
  {
    id: 1,
    category: "Music",
    isBoosted: true, // ✨ Boosted Content
    creator: {
      name: "Sewasew",
      username: "sewasew",
      profilePicture: "https://i.pravatar.cc/150?u=sewasew",
    },
    timestamp: "8h ago",
    content:
      "Behind the scenes from my last show in Addis Ababa. The energy was incredible! Who's coming to the next one?",
    imageUrl: null,
    stats: {
      likes: 456,
      comments: 32,
    },
  },
  {
    id: 2,
    category: "Music",
    creator: {
      name: "Gigi Kiya",
      username: "gigiMusic",
      profilePicture: "https://i.pravatar.cc/100?u=gigi",
    },
    timestamp: "1d ago",
    content:
      "So excited to announce my upcoming concert in Addis! Can't wait to see you all there. Get your tickets now!",
    imageUrl: null,
    stats: {
      likes: 5200,
      comments: 350,
    },
  },
  {
    id: 3,
    category: "Music",
    creator: {
      name: "Gigi Kiya",
      username: "gigiMusic",
      profilePicture: "https://i.pravatar.cc/100?u=gigi",
    },
    timestamp: "3d ago",
    content: "Studio Session: New Single Preview! This one is for the fans.",
    imageUrl:
      "https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=400",
    stats: {
      likes: 2500,
      comments: 2,
    },
    comments: [
      {
        id: "c1",
        author: {
          name: "Alex Abera",
          avatarUrl: "https://i.pravatar.cc/100?u=alex",
        },
        text: "This sounds amazing!",
        timestamp: "1d ago",
        likes: 15,
        replies: [
          {
            id: "r1",
            author: {
              name: "Gigi Kiya",
              avatarUrl: "https://i.pravatar.cc/100?u=gigi",
            },
            text: "Thank you so much! 🙏",
            timestamp: "1d ago",
            likes: 45,
          },
        ],
      },
      {
        id: "c2",
        author: {
          name: "Betty Tesfaye",
          avatarUrl: "https://i.pravatar.cc/100?u=betty",
        },
        text: "The vibes are immaculate. 🔥",
        timestamp: "4h ago",
        likes: 2,
      },
    ],
  },
  {
    id: 4,
    category: "Comedy",
    isBoosted: true, // ✨ Boosted Content
    creator: {
      name: "Comedian Eshetu",
      username: "eshetu",
      profilePicture: "https://i.pravatar.cc/100?u=eshetu",
    },
    timestamp: "2h ago",
    content:
      "Just dropped a new skit on YouTube! Check it out and let me know what you think. Link in bio!",
    imageUrl: null,
    stats: {
      likes: 12000,
      comments: 450,
    },
    comments: [],
  },
  {
    id: 5,
    category: "Art & Design",
    creator: {
      name: "Rakeb Alemayehu",
      username: "rakeb",
      profilePicture: "https://i.pravatar.cc/100?u=rakeb",
    },
    timestamp: "5h ago",
    content:
      "New painting completed! This piece represents the vibrant culture of Ethiopia. Prints available!",
    imageUrl: "https://images.unsplash.com/photo-1578301978018-3005759f48f7?w=400",
    stats: {
      likes: 890,
      comments: 42,
    },
    comments: [],
  },
  {
    id: 6,
    category: "Food & Drink",
    creator: {
      name: "Gursha Desserts",
      username: "gursha",
      profilePicture: "https://i.pravatar.cc/100?u=gursha",
    },
    timestamp: "12h ago",
    content:
      "Today's special: Honey-glazed tibs with injera. Limited quantities available for delivery!",
    imageUrl: "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=400",
    stats: {
      likes: 2340,
      comments: 156,
    },
    comments: [],
  },
  {
    id: 7,
    category: "Comedy",
    creator: {
      name: "Comedian Eshetu",
      username: "eshetu",
      profilePicture: "https://i.pravatar.cc/100?u=eshetu",
    },
    timestamp: "1d ago",
    content:
      "When you try to speak English in a professional meeting but the Amharic accent says hello 😂",
    imageUrl: null,
    stats: {
      likes: 8500,
      comments: 320,
    },
    comments: [],
  },
  {
    id: 8,
    category: "Lifestyle",
    creator: {
      name: "Fitness Meklit",
      username: "fitnessmeklit",
      profilePicture: "https://i.pravatar.cc/100?u=meklit",
    },
    timestamp: "18h ago",
    content:
      "Morning workout complete! Remember: Consistency beats perfection. What's your fitness goal this month?",
    imageUrl: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=400",
    stats: {
      likes: 1240,
      comments: 89,
    },
    comments: [],
  },
  {
    id: 9,
    category: "Tech",
    creator: {
      name: "Addis Tech Reviews",
      username: "addistech",
      profilePicture: "https://i.pravatar.cc/100?u=addistech",
    },
    timestamp: "6h ago",
    content:
      "Full review of the new Tecno phone just dropped! Best budget smartphone in Ethiopia right now? Link in bio!",
    imageUrl: null,
    stats: {
      likes: 1850,
      comments: 112,
    },
    comments: [],
  },
  {
    id: 10,
    category: "Music",
    creator: {
      name: "Gigi Kiya",
      username: "gigiMusic",
      profilePicture: "https://i.pravatar.cc/100?u=gigi",
    },
    timestamp: "4d ago",
    content:
      "Throwback to my first performance in 2018. The journey has been incredible. Thank you for all the love and support!",
    imageUrl: "https://images.unsplash.com/photo-1501386761578-eac5c94b800a?w=400",
    stats: {
      likes: 6700,
      comments: 234,
    },
    comments: [],
  },
];

export const ethiopianPaymentProviders = {
  banks: [
    "Commercial Bank of Ethiopia",
    "ENAT Bank",
    "Awash Bank",
    "Dashen Bank",
    "Bank of Abyssinia",
    "Wegagen Bank",
    "Zemen Bank",
    "Hibret Bank",
  ],
  mobileMoney: ["Telebirr", "M-PESA", "Ferq"],
};

export const creatorCategories = [
  { name: "Music", icon: "🎵" },
  { name: "Comedy", icon: "😂" },
  { name: "Art & Design", icon: "🎨" },
  { name: "Film & Video", icon: "🎬" },
  { name: "Food & Drink", icon: "🍔" },
  { name: "Lifestyle", icon: "😎" },
  { name: "Tech", icon: "💻" },
  { name: "Gaming", icon: "🎮" },
];

export const mockAdmin = {
  username: "platform_admin",
  fullName: "Adnaki Admin",
  role: "admin",
  profilePictureUrl: "https://placehold.co/100x100/4338CA/FFFFFF?text=A",
};

export const mockNotifications = [
  {
    id: "N001",
    type: "new_post",
    creatorName: "Gigi Kiya",
    creatorProfilePictureUrl: "https://i.pravatar.cc/100?u=gigi",
    text: "published a new video: 'Studio Session Preview!'",
    timestamp: "2h ago",
    isRead: false,
  },
  {
    id: "N002",
    type: "message",
    creatorName: "Betty Tesfaye",
    creatorProfilePictureUrl: "https://i.pravatar.cc/100?u=betty",
    text: "sent you a message.",
    timestamp: "1d ago",
    isRead: false,
  },
  {
    id: "N003",
    type: "subscription",
    creatorName: "Sewasew",
    creatorProfilePictureUrl: "https://i.pravatar.cc/100?u=sewasew",
    text: "Your subscription is renewing soon.",
    timestamp: "3d ago",
    isRead: true,
  },
  {
    id: "N004",
    type: "tip_thanks",
    creatorName: "Gigi Kiya",
    creatorProfilePictureUrl: "https://i.pravatar.cc/100?u=gigi",
    text: "thanked you for your recent tip!",
    timestamp: "4d ago",
    isRead: true,
  },
];

export const systemUsers = [
  {
    id: "admin_1",
    name: "Admin User",
    email: "admin@adnaki.com",
    role: "Super Admin",
    status: "Active",
    lastActive: "Just now",
  },
  {
    id: "mod_1",
    name: "Content Moderator",
    email: "mod@adnaki.com",
    role: "Content Moderator",
    status: "Active",
    lastActive: "2 hours ago",
  },
  {
    id: "fin_1",
    name: "Finance Team",
    email: "finance@adnaki.com",
    role: "Finance Manager",
    status: "Active",
    lastActive: "1 day ago",
  },
];

// Post Interactions Data
export const postInteractions = {
  post_1: {
    likes: 234,
    comments: 45,
    shares: 12,
    views: 1543,
    savedBy: ["fan_1", "fan_2"],
    likedBy: ["fan_1", "fan_3", "fan_4"]
  },
  post_2: {
    likes: 567,
    comments: 89,
    shares: 23,
    views: 3421,
    savedBy: ["fan_1"],
    likedBy: ["fan_1", "fan_2"]
  },
  post_3: {
    likes: 123,
    comments: 34,
    shares: 8,
    views: 876,
    savedBy: [],
    likedBy: ["fan_3"]
  }
};

// Comments Data
export const comments = [
  {
    id: "comment_1",
    postId: "post_1",
    userId: "fan_1",
    userName: "Abebe Tesfaye",
    userAvatar: "https://i.pravatar.cc/40?u=fan1",
    text: "Amazing content! Can't wait for more! 🔥",
    timestamp: "2h ago",
    likes: 12,
    replies: [
      {
        id: "reply_1",
        userId: "creator_1",
        userName: "Gigi Kiya",
        userAvatar: "https://i.pravatar.cc/40?u=creator1",
        text: "Thank you so much for the support! ❤️",
        timestamp: "1h ago",
        likes: 5
      }
    ]
  },
  {
    id: "comment_2",
    postId: "post_1",
    userId: "fan_2",
    userName: "Mekdes Alemu",
    userAvatar: "https://i.pravatar.cc/40?u=fan2",
    text: "This is exactly what I needed today!",
    timestamp: "3h ago",
    likes: 8,
    replies: []
  },
  {
    id: "comment_3",
    postId: "post_2",
    userId: "fan_3",
    userName: "Dawit Bekele",
    userAvatar: "https://i.pravatar.cc/40?u=fan3",
    text: "Keep up the great work! 👏",
    timestamp: "5h ago",
    likes: 15,
    replies: []
  }
];

// Notifications Data
export const notifications = [
  {
    id: "notif_1",
    type: "like",
    message: "Abebe Tesfaye liked your post",
    postId: "post_1",
    timestamp: "10m ago",
    read: false,
    icon: "Heart",
    avatarUrl: "https://i.pravatar.cc/40?u=fan1"
  },
  {
    id: "notif_2",
    type: "comment",
    message: "Mekdes Alemu commented on your post",
    postId: "post_1",
    timestamp: "1h ago",
    read: false,
    icon: "MessageCircle",
    avatarUrl: "https://i.pravatar.cc/40?u=fan2"
  },
  {
    id: "notif_3",
    type: "follow",
    message: "Dawit Bekele started following you",
    timestamp: "2h ago",
    read: true,
    icon: "UserPlus",
    avatarUrl: "https://i.pravatar.cc/40?u=fan3"
  },
  {
    id: "notif_4",
    type: "subscription",
    message: "Sara Mulugeta subscribed to your content",
    timestamp: "3h ago",
    read: true,
    icon: "Star",
    avatarUrl: "https://i.pravatar.cc/40?u=fan4"
  },
  {
    id: "notif_5",
    type: "message",
    message: "New message from Abebe Tesfaye",
    timestamp: "5h ago",
    read: true,
    icon: "Mail",
    avatarUrl: "https://i.pravatar.cc/40?u=fan1"
  }
];

export const trendingCreators = [
  {
    id: "TR-001",
    name: "Gigi Kiya",
    username: "gigiMusic",
    avatarUrl: "https://i.pravatar.cc/100?u=gigi",
    category: "Music",
    trend: "+24%",
    followers: "1.2M"
  },
  {
    id: "TR-002",
    name: "Comedian Eshetu",
    username: "eshetu",
    avatarUrl: "https://i.pravatar.cc/100?u=eshetu",
    category: "Comedy",
    trend: "+18%",
    followers: "850K"
  },
  {
    id: "TR-003",
    name: "Rakeb Alemayehu",
    username: "rakeb",
    avatarUrl: "https://i.pravatar.cc/100?u=rakeb",
    category: "Lifestyle",
    trend: "+12%",
    followers: "420K"
  }
];

export const hotMedia = [
  {
    id: "HM-001",
    title: "Unity (Live Session)",
    creator: "Gigi Kiya",
    imageUrl: "https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=200",
    duration: "4:32",
    type: "Video",
    views: "1.2M"
  },
  {
    id: "HM-002",
    title: "The Weekend Roast",
    creator: "Comedian Eshetu",
    imageUrl: "https://images.unsplash.com/photo-1527224857830-43a7acc85260?w=200",
    duration: "12:15",
    type: "Video",
    views: "850K"
  },
  {
    id: "HM-003",
    title: "Sunset Chords",
    creator: "Gigi Kiya",
    imageUrl: "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=200",
    duration: "3:45",
    type: "Audio",
    views: "420K"
  }
];

